import {
  beRecipientAddGroup,
  beRecipientGetGroupDetails,
  beRecipientGetListOfGroupDetails,
  GROUPS_SEARCH_TYPE_ECONTAINS,
  GROUPS_SEARCH_TYPE_EQUALTO,
} from "Api/beRecipientApi";

import { STORE_KEY_ID_LIST, storeGet } from "mailup-react-helpers";

import { INPUT_MESSAGES_MAX_ITEMS } from "Constants";

export const fetchGroups = async (
  searchTerm: string,
): Promise<{
  items: Array<{ label: string; value: number }>;
  totalItems: number;
}> => {
  const idList = storeGet(STORE_KEY_ID_LIST);

  const { Items, TotalItems } = await beRecipientGetListOfGroupDetails(idList, {
    searchType: "CONTAINS",
    searchBy: searchTerm,
    orderBy: "Id",
    orderDescending: true,
    pageNumber: 1,
    pageSize: INPUT_MESSAGES_MAX_ITEMS,
  });

  return {
    items: Items.map(({ Id, Name }: { Id: number; Name: string }) => ({
      value: Id,
      label: `${Id} - ${Name}`,
    })),
    totalItems: TotalItems,
  };
};

export const fetchGroupById = async (
  id: number,
): Promise<{ label: string; value: number } | undefined> => {
  const res: { Id: number; Name: string } | null | undefined =
    await beRecipientGetGroupDetails(id);

  if (res !== null && res !== undefined) {
    return {
      value: res.Id,
      label: `${res.Id} - ${res.Name}`,
    };
  }

  return undefined;
};

export const addGroup = async (name: string): Promise<any> => {
  const idList = storeGet(STORE_KEY_ID_LIST);

  const existing = await beRecipientGetListOfGroupDetails(idList, {
    searchBy: name,
    searchType: "EQUALTO",
    pageSize: 1,
    pageNumber: 1,
    orderBy: "",
    orderDescending: false,
  });

  if (existing.TotalItems > 0) {
    return existing.Items[0];
  }

  const newItem = await beRecipientAddGroup({
    IdList: idList,
    Name: name,
    Notes: "",
    Type: "Normal",
    Deleteable: true,
  });

  return newItem;
};

export async function getGroups(searchBy: string, exact = false) {
  const idList = storeGet(STORE_KEY_ID_LIST);
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: "Id",
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchBy,
    searchType: exact
      ? GROUPS_SEARCH_TYPE_EQUALTO
      : GROUPS_SEARCH_TYPE_ECONTAINS,
  });
  return Items.map(({ Id, Name, Notes }: { Id: number; Name: string; Notes: string }) => {
    return ({
      label: `${Id} - ${Name}${Notes ? ` (${Notes})` : ""}`,
      value: Id,
    });
  });
}
